// extracted by mini-css-extract-plugin
export default {"text":"hiwText_text__Tltzn"};